import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]公告列表
 */
export function queryFundAnnouncementUsingPOST(
  req: InfoPageDto | void,
  config?: RequestConfig
): Promise<ApiResultPageLcAnnouncement> {
  return resource.postNoAuth('/fundAnnounce/queryFundAnnouncement', req, config);
}

/**
 * [No Auth]分红
 */
export function queryFundDividendUsingPOST(
  req: InfoPageDto | void,
  config?: RequestConfig
): Promise<ApiResultPageLcDividend> {
  return resource.postNoAuth('/fundAnnounce/queryFundDividend', req, config);
}
